var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "ci-emptystate",
        { attrs: { "locale-path": "social_events", "image-type": "events" } },
        [
          _c(
            "div",
            { staticClass: "row d-flex flex-wrap" },
            [
              _c("ci-button", {
                staticClass: "to-notification-settings mr-md-3",
                attrs: {
                  variant: "outline-primary",
                  to: {
                    name: _vm.$routes.USERS_SETTINGS,
                    query: { tab: "notifications" },
                  },
                  size: "md",
                  label: _vm.$t(
                    "ui.components.social_events.empty_state.to_notification_settings"
                  ),
                },
              }),
              _c("ci-button", {
                staticClass: "to-investment-profile mb-3 mb-md-0",
                attrs: {
                  variant: "filled-primary",
                  to: {
                    name: _vm.$routes.USERS_SETTINGS,
                    query: { tab: "investment_profile" },
                  },
                  size: "md",
                  label: _vm.$t(
                    "ui.components.social_events.empty_state.to_investment_profile"
                  ),
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }